import { render, staticRenderFns } from "./Pregnant.vue?vue&type=template&id=32b2f1dd&scoped=true&"
import script from "./Pregnant.vue?vue&type=script&lang=js&"
export * from "./Pregnant.vue?vue&type=script&lang=js&"
import style0 from "./Pregnant.vue?vue&type=style&index=0&id=32b2f1dd&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2f1dd",
  null
  
)

export default component.exports